import React, { Component } from 'react'
import './index.less'

interface LookCodeCellProps {
    qcode_url: string
    pwd: string
}
export default class LookCodeCell extends Component<LookCodeCellProps> {
    render() {
        return (
            <div className='lookcode-bg'>
                <div className='lookcode-cell'>
                    <span className='lookcode-cell-tips'>到达门店后，请向客服人员出示此二维码</span>
                    <img className='lookcode-img' src={this.props.qcode_url} alt="取货码" />
                    <span className='lookcode-pwd'>服务密码：{this.props.pwd}</span>
                </div>
            </div>

        )
    }
}